import { isPlatformServer } from '@angular/common';
import { inject, Injectable, PLATFORM_ID } from '@angular/core';
import { hasConsent } from './consent.utility';

declare global {
    interface Window {
        OnetrustActiveGroups?: string;
    }
}

@Injectable({
    providedIn: 'root',
})
export class ConsentService {
    protected readonly platformId: object = inject(PLATFORM_ID);

    hasConsent(groupId: string): boolean {
        if (isPlatformServer(this.platformId)) return false;

        return hasConsent(window.OnetrustActiveGroups, groupId);
    }
}
